import { useQuery } from 'convex/react';
import type { FunctionReturnType } from 'convex/server';
import { api } from '@aeon-karaoke/cloud-convex';
import { useCurrentUser } from './useCurrentUser';

export type HistoryRow = FunctionReturnType<typeof api.history.mine>[number];

/** The caller's most recent performances, newest first, capped server-side at
 * a long stretch of nights. The page groups them into nights, which needs the
 * reader's timezone. */
export function useHistory() {
  const { user } = useCurrentUser();
  return useQuery(api.history.mine, user ? {} : 'skip');
}
